<script>

    import { toast } from 'bulma-toast'
    import { shopifysStore, modalStore } from '../stores'

    import ShopifyService from '../$services/shopify.service'

    import Form from '../$components/form.svelte'
    import Select from '../$components/select.svelte'
    import InputText from '../$components/input.text.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import SelectUser from '../$components/select.users.svelte'

    let loading = false
    let data = {}

    async function createShopifyApp() {
    
        loading = true
        const resp = await ShopifyService.createShopifyApp(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        shopifysStore.append(resp.data)
        modalStore.close()
    }

</script>

<Form on:submit={createShopifyApp} { loading } >

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.domain} label="Dominio" placeholder="dominio" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <SelectUser bind:userId={ data.userId } />
        </div>
    </div>

    <div class="items-end">
        <div class="buttons">
            <ButtonSave />
        </div>
    </div>
</Form>